import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Spin,
  Row,
  Modal,
} from 'antd';
import {
  ArrowLeftOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import { onError } from 'utils/handlers';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import { patchCiudadano } from 'api/cuentaunicasir';
import LadaNumero from './LadaNumero';

const UpdateCiudadano = ({
  visible,
  setVisible,
  callback,
  ciudadano,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const patch = await patchCiudadano(ciudadano, values);
      if (patch) {
        callback(patch);
        onCancel();
      }
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const controls = [
    {
      text: 'Regresar',
      icon: <ArrowLeftOutlined />,
      onClick: () => onCancel(),
    },
    {
      text: 'Guardar',
      icon: <SaveOutlined />,
      onClick: () => {
        onFinish();
      },
    },
  ];

  return (
    <>
      <Modal
        width="90%"
        visible={visible}
        closable={false}
        footer={null}
        title={(
          <Row justify="space-between">
            Actualizar Datos del ciudadano
            <FormSubmitControls
              controls={controls}
              loading={loading}
            />
          </Row>
        )}
        onCancel={onCancel}
        maskClosable={!loading}
        keyboard={!loading}
        forceRender
        centered
      >
        <Spin tip="Cargando..." spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Row gutter={10}>
              <LadaNumero
                form={form}
                fullSize
                names={{
                  lada: 'lada',
                  numero_de_telefono: 'numero_de_celular',
                }}
              />
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

UpdateCiudadano.propTypes = {
  callback: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  ciudadano: PropTypes.number,
};

UpdateCiudadano.defaultProps = {
  ciudadano: null,
};

export default UpdateCiudadano;
